import React, { Component } from 'react';
import { connect } from 'react-redux';

import './DeviceRecoveryApp.module.css';
import { IntlProvider } from "react-intl";
import Langs from './../../lang/lang';
import Main from './../Main/Main';
import actions from './../../store/actions/index';
import { IS_PRE_LOGIN, USER_ID, LOCALE, IS_SURVEY_RESPONSE, IS_UAM_TEAM_INVITE, IS_PRICE_LIST_APPROVAL } from './../../libs/constants';
import Loader from '../../components/Loader/Loader';
import { prepareGetTokenRequestDataForGuest } from './../../libs/prepare-request-data';
import AppModal from '../../components/AppModal/AppModal';
import md5 from 'crypto-js/md5';
import { redirectForAuthentication, redirectForSignOut } from '../../libs/handle-user-exit';

class DeviceRecoveryApp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            proceedTo: "",
            appCrashed: false
        };
    }

    componentDidMount() {
        if (!IS_PRE_LOGIN) {
            if (USER_ID) {
                // user came from HPID platform
                this.props.dispatch(actions.authorization.getUserInfo(USER_ID));
            } else if (IS_SURVEY_RESPONSE) {
                this.setState({ proceedTo: "survey" });
            } else if (IS_UAM_TEAM_INVITE) {
                this.setState({ proceedTo: "teamInvite" });
            } else if (IS_PRICE_LIST_APPROVAL) {
                redirectForAuthentication("login");
            } else {
                // user came directly
                //this.props.dispatch(actions.authorization.getAuthTokenForGuest(prepareGetTokenRequestDataForGuest()));
                this.props.dispatch(actions.authorization.getUserInfo());
            }
        } else {
            this.setState({ proceedTo: "prelogin" });
        }

        this.props.dispatch(actions.app.setWarnUserBeforeExit(false));
        window.addEventListener('beforeunload', this.beforeunload.bind(this));
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.postChangedPasswordRequest !== this.props.postChangedPasswordRequest) && this.props.postChangedPasswordRequest) {
            redirectForSignOut();
        }

        if (prevProps.userId !== this.props.userId && (this.props.userId && !this.props.authenticated && !this.props.hasServerResponded && !this.props.priceListUploadId)) {
            // If user has been redirected from HPID, check if user exists in system database
            this.props.dispatch(actions.userProfile.getUser(this.props.userId));
        }

        if (prevProps.hasServerResponded !== this.props.hasServerResponded && (this.props.userId && this.props.hasServerResponded && this.props.authenticated)) {
            // If user has been redirected from HPID and exists in system database, proceed to dashboard
            this.setState({ proceedTo: "overview" });

            // Register analytic tracking event - start
            window.dataLayer.push({
                event: "e_userLogin",
                userID: md5(this.props.profileUserId)
            });
            // Register analytic tracking event - end
        }

        if (prevProps.hasServerResponded !== this.props.hasServerResponded && (this.props.userId && this.props.hasServerResponded && !this.props.authenticated)) {
            // If user has been redirected from HPID and doesn't exist in system database, proceed to app register page
            this.setState({ proceedTo: "register" });
        }

        if (prevProps.authenticated !== this.props.authenticated && (this.props.authenticated && this.state.proceedTo === "register")) {
            // User gets authneticated after succesfully submitting app registration form
            this.setState({ proceedTo: "overview" });

            // Register analytic tracking event - start
            window.dataLayer.push({
                event: "e_userRegister",
                userID: md5(this.props.profileUserId)
            });
            // Register analytic tracking event - end
        }

        if (prevProps.userInfoCallComplete !== this.props.userInfoCallComplete && (this.props.userInfoCallComplete && !this.props.userId && this.props.siteUnderMaintenance)) {
            // Site is under maintenance, proceed to show the maintenance page
            this.setState({ proceedTo: "maintenance" });
        }

        if (prevProps.userInfoCallComplete !== this.props.userInfoCallComplete && (this.props.userInfoCallComplete && this.props.userId && this.props.priceListUploadId)) {
            this.setState({ proceedTo: "priceApproval" });
        }

        if (prevProps.userInfoCallComplete !== this.props.userInfoCallComplete && (this.props.userInfoCallComplete && !this.props.userId && !this.props.siteUnderMaintenance && !this.props.postChangedPasswordRequest)) {
            // If invalid user id passed in URL, get auth token for guest
            this.props.dispatch(actions.authorization.getAuthTokenForGuest(prepareGetTokenRequestDataForGuest()));
        }

        if (prevProps.token !== this.props.token && (this.props.tokenCallComplete && this.props.token)) {
            // Token received for guest, proceed to guest recycle page
            this.setState({ proceedTo: "recycle" });
        }

        if (prevProps.tokenCallComplete !== this.props.tokenCallComplete && (this.props.tokenCallComplete && !this.props.token)) {
            // Token not received, show error message
            alert("System error. Please try again later");
        }
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.beforeunload.bind(this));
    }

    static getDerivedStateFromError(error) {
        return { appCrashed: true };
    }

    componentDidCatch(error, errorInfo) {
        console.log({ error, errorInfo })
    }

    beforeunload(e) {
        if (this.props.warnUserBeforeExit) {
            e.preventDefault();
            e.returnValue = true;
        }
    }

    render() {

        let appLayout = null;

        if (this.state.proceedTo) {
            appLayout = (
                <>
                    <Loader loading={this.props.loading} />
                    <Main
                        proceedTo={this.state.proceedTo}
                        authenticated={this.props.authenticated}
                        leftOverOrder={this.props.leftOverOrder}
                        appCrashed={this.state.appCrashed}
                        captchaEnable={this.props.captchaEnable}
                    />
                    <AppModal />
                </>
            );
        }
        else {
            appLayout = (
                <Loader loading={true} />
            )
        }

        return (
            <IntlProvider locale={LOCALE} messages={{ ...this.props.appMessages }}>
                {appLayout}
                <Langs />
            </IntlProvider>
        );
    }
}

const mapStateToProps = state => {
    return {
        warnUserBeforeExit: state.app.warnUserBeforeExit,
        token: state.authorization.token,
        tokenCallComplete: state.authorization.tokenCallComplete,
        userInfoCallComplete: state.authorization.userInfoCallComplete,
        userId: state.authorization.userId,
        authenticated: state.userProfile.authenticated,
        profileUserId: state.userProfile.userId,
        hasServerResponded: state.userProfile.hasServerResponded,
        loading: state.app.loading,
        leftOverOrder: state.newOrder.leftOverOrder,
        siteUnderMaintenance: state.authorization.siteUnderMaintenance,
        priceListUploadId: state.authorization.priceListUploadId,
        appMessages: state.app.messages,
        captchaEnable: state.authorization.captchaEnable,
        postChangedPasswordRequest: state.authorization.postChangedPasswordRequest
    }
}

export default connect(mapStateToProps)(DeviceRecoveryApp);
